module.exports = __webpack_public_path__ + "media/images/bg_shade-29cbc60b1dd034865996e4363ac8eb33.svg";